﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum odeslání</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.sentInvestorDate" [maxToday]="true"/></div>
  </div>
</fieldset>
